<template>
    <div class="mx-2  pt-2 "  style="height:90vh">
        <div class="flex justify-between mt-10 md:mt-0 items-baseline	">
            <h1 style="font-weight: 550;" class="text-2xl  mb-5 md:mt-10 mt-3">SOPs </h1>
            <!-- v-if="hasCnaCreateUser" -->
            <router-link v-if="hasCnaCreateSops" to="/createsops" style="background: #2E2C72;"
                class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-regal-blue dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Create
                SOP
            </router-link>
        </div>
        <div class="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between  pb-4">
            <div>
                <span class="text-base">
                    show:
                    <select @change="fetchSops('isshowuser')" v-model="number" class="rounded-lg" id="quantity"
                        name="quantity" style="border: 1px solid white; border-top: #F9F9F9;">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                    </select>
                    &nbsp; entries
                </span>
            </div>
            <form>
                <label for="default-search"
                    class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
                <div class="relative">
                    <input type="search" v-model="searchQuery" style="padding-left: 20px; width: 350px; "
                        id="default-search"
                        class="block w-full p-4 pl-10 ps-20 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Search" required>
                    <button type="button" @click.prevent="handlesearch"
                        class="text-white bg-button-blue absolute end-2.5 bottom-2  hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-[10px] py-[12px] dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        <svg style="" class="w-10 h-4  text-white dark:text-gray-400" aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg></button>
                </div>
            </form>
        </div>
        <div class="relative overflow-x-auto overflow-hidden  shadow-md ">
            <table class="w-full text-sm  border text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700  bg-stone-300 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" class="px-6 py-3">
                            Id
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Note
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                File 
                            </div>
                        </th>
                        <!-- <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                City
                            </div>
                        </th> -->
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Created At
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Updated At
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Created By
                            </div>
                        </th>
                        <th scope="col" class="px-6 py-3">
                            <div class="flex items-center">
                                Updated By
                            </div>
                        </th>
                        <!-- v-if="hascanupdateuser" -->
                        <!-- <th scope="col" class="px-6 py-3" v-if="hascanupdateCity">
                            <span class="flex items-center ">Edit</span>
                        </th> -->
                        <!-- v-if="hascandeleteuser" -->
                        <th scope="col" class="px-6 py-3" v-if="hascanDeleteSops">
                            <span class="flex items-center">Delete</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="teh in tehsil" :key="teh.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{{ teh.id }}
                        </td>
                        <td class="px-6 py-4">{{ teh?.note }}</td>
                        <td class="px-6 py-4"><a class="text-blue-500" target="_blank" :href="teh?.full_file_path">Download File</a></td>
                        <!-- <td class="px-6 py-4">{{ teh?.district?.name }}</td> -->
                        <td class="px-6 py-4"> {{ teh?.created_at }}</td>
                        <td class="px-6 py-4"> {{ teh?.updated_at }}</td>
                        <td class="px-6 py-4"> {{ teh?.created_by?.display_name }}</td>
                        <td class="px-6 py-4"> {{ teh?.updated_by?.display_name }}</td>
                      
                        <td class="px-6 py-4 "  style="cursor: pointer;" v-if="hascanDeleteSops">
                            <a @click="delteuser(teh.id)" style="color: red;"
                                class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Delete</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex justify-end mt-2">
            <vue-awesome-paginate :total-items="totalpage" class="overflow-hidden pl-5" :items-per-page="1"
                :max-pages-shown="5" v-model="currentPage" :on-click="onClickHandler" :hide-prev-next-when-ends="true"
                next-button-content=">" />
        </div>
    </div>
</template>
<script setup>
import { ref, watch, computed, onMounted, onUpdated } from 'vue';
import axiosInstance from "@/plugins/axios"
import Swal from 'sweetalert2';
const tehsil = ref()
// const chunk = ref(1)
const number = ref(10)
const currentPage = ref(1);
const totalpage = ref()
const searchQuery = ref('');

// const handleFileUpload = (event) => {
//   const file = event.target.files[0];
//   uploadFile(file);
// };

// const uploadFile = async (file) => {
//     pageLoader.value = true;
//     try {
//         const formData = new FormData();
//         formData.append('file', file);

//         const response = await axiosInstance.post('/users/import', formData, {
//             headers: {
//                 'Content-Type': 'multipart/form-data'
//             }
//         });
//         pageLoader.value = false;

//         Swal.fire({
//             icon: 'success',
//             title: 'City imported successfully',
//             text: ''
//         });
//     } catch (error) {
//         pageLoader.value = false;
//         Swal.fire({
//             icon: 'warning',
//             title: 'City import failed',
//             text: error.response.data.message
//         });
//     }
// };

const delteuser = async (id) => {
    const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this sops?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    });
    const response = await axiosInstance.delete(`/sops/${id}`);

    if (confirmed.isConfirmed) {
        try {

            Swal.fire(
                'Deleted!',
                'Your sops has been deleted.',
                'success'
            );
            fetchSops()
        } catch (error) {
            console.error('Failed to delete sops:', error);
            Swal.fire(
                'Error!',
                'Failed to delete sops.',
                'error'
            );
        }
    }
};

const handlesearch = async (e) => {
    await fetchSops('isshowuser');
}
const fetchSops = async (isshowuser) => {
    try {
        if (isshowuser === 'isshowuser') {
            currentPage.value = 1
            const response = await axiosInstance.get(`/sops/${number.value}/${searchQuery.value}/?page=${currentPage.value}`);
            tehsil.value = response.data.data.data
            totalpage.value = response.data.data.last_page;
        } else {
            const response = await axiosInstance.get(`/sops/${number.value}/?page=${currentPage.value}`);
            tehsil.value = response.data.data.data
            totalpage.value = response.data.data.last_page;
            // console.log(response.data.data.data, 'hhhhhhhhhhhhhhhhhhhh')
        }

    } catch (error) {
        console.error('Error fetching district info:', error);
        // Handle error or show error message
    }
}
const onClickHandler = () => {
    fetchSops()
    // pagniationpage.value =  true
}

import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const permissions = ref([])
onMounted(() => {
    const authData = authStore.authData;
    permissions.value = authStore.authData.permissions

});
const hasCnaCreateSops = computed(() => permissions.value.some(permission => permission.name === 'can create sop'));
const hascanDeleteSops = computed(() => permissions.value.some(permission => permission.name === 'can delete sop'));
// const hascandeleteTehsil = computed(() => permissions.value.some(permission => permission.name === 'can delete tehsil'));


onMounted(() => {
    fetchSops()
})
</script>